module.exports = __webpack_public_path__ + "img/bakground-hammann.b7048fb8.jpg";